import React, { useEffect } from 'react';
import { NEXTGEN_APP_URL } from '../../config';

const Settings = () => {
  useEffect(() => {
    window.location.href = `${NEXTGEN_APP_URL}/settings`;
  }, []);

  return null;
};

export default Settings;
